import { updateDoc, serverTimestamp } from "firebase/firestore";

export async function checkAndExpireTrial(userDocRef, userData) {
  if (!userData?.trial?.endDate) return userData;

  const endDate =
    userData.trial.endDate?.toDate?.() ||
    new Date(userData.trial.endDate);

  if (endDate < new Date() && userData.trial.status !== "expired") {
    await updateDoc(userDocRef, {
      "trial.status": "expired",
      "trial.updatedAt": serverTimestamp(),
    });

    return {
      ...userData,
      trial: {
        ...userData.trial,
        status: "expired",
      },
    };
  }

  return userData;
}
